import type { AuthenticatedRequest} from '@app/rest/rest.lib';
import { authenticatedRequest } from '@app/rest/rest.lib'

import type { IEntry } from '../instrument/instrument.interface'
import type { IPatientId } from '../patient/patient.interface'
import type { IDataInstrument, PdfTemplate } from '../visit/visit.interface'

export type IInteractionResponse = {
  id: string
  patientId: IPatientId
  visitId: string | undefined
  entries: IEntry[]
  instruments: IDataInstrument[]
}

export function getInteraction(
  interactionId: string,
): AuthenticatedRequest<IInteractionResponse> {
  const url = `/api/v2/interaction/${interactionId}`

  return authenticatedRequest<IInteractionResponse>({
    method: 'get',
    url,
  })
}

export type IInteractionCommunicationConsentResponse = {
  interactionId: string
  didConsent: boolean
  updatedAt: Date
}

export function getInteractionCommunicationConsent(
  interactionId: string,
): AuthenticatedRequest<IInteractionCommunicationConsentResponse> {
  const url = `/api/v2/interaction/${interactionId}/communicationConsent`

  return authenticatedRequest<IInteractionCommunicationConsentResponse>({
    method: 'get',
    url,
  })
}

export type IInteractionReportTemplatesResponse = {
  reportTemplates: PdfTemplate[]
}

export function getInteractionReportTemplates(
  interactionId: string,
): AuthenticatedRequest<IInteractionReportTemplatesResponse> {
  const url = `/api/v2/interaction/${interactionId}/reportTemplates`

  return authenticatedRequest<IInteractionReportTemplatesResponse>({
    method: 'get',
    url,
  })
}

export function requestInteractionPDF(
  interactionId: string,
  templateId: string,
) {
  return authenticatedRequest({
    method: 'get',
    responseType: 'blob',
    url: `/api/v2/interaction/${interactionId}/${templateId}/authenticatedPDF`,
  })
}
